import { createActions } from 'redux-actions'

const { toggleFlightSummary, toggleFlightItinerary, toggleOffersFilters } = createActions({
  TOGGLE_FLIGHT_SUMMARY: visible => ({ visible }),
  TOGGLE_FLIGHT_ITINERARY: visible => ({ visible }),
  TOGGLE_OFFERS_FILTERS: (visible, filter) => ({ visible, filter })
})

export { toggleFlightSummary, toggleFlightItinerary, toggleOffersFilters }
